import { getMenus, getPages, getConfigLayout, getEnvironments } from '@/services/dev';

export default {
  getMenus: async ({ commit, state }) => {
    if (state.selectedModule) {
      const { data } = await getMenus({
        portalId: state.selectedPortal.portalId,
        moduleId: state.selectedModule.id,
        moduleFolder: state.selectedModule.folder
      });

      commit('setMenus', data);
    }
  },

  getPages: async ({ commit, state }) => {
    if (state.selectedModule) {
      const { data } = await getPages({
        portalId: state.selectedPortal.portalId,
        moduleId: state.selectedModule.id,
        moduleFolder: state.selectedModule.folder
      });

      commit('setPages', data);
    }
  },

  getConfigLayout: async ({ commit, state }) => {
    if (state.selectedPortal) {
      const { data } = await getConfigLayout(state.selectedPortal.portalId);

      commit('setConfigLayout', data);
    }
  },

  getEnvironments: async ({ commit }) => {
    const { data } = await getEnvironments();

    commit('setEnvironments', data);
  },

  clearMenus: ({ commit }) => commit('clearMenus'),

  setSchema: ({ commit }, payload) => commit('setSchema', payload),

  setInitialSchema: ({ commit }, payload) => commit('setInitialSchema', payload),

  setModes: ({ commit }, payload) => commit('setModes', payload),

  setTypeOfPageEditing: ({ commit }, payload) => commit('setTypeOfPageEditing', payload),

  setConfirmPageChanges: ({ commit }, payload) => commit('setConfirmPageChanges', payload),

  setSelected: ({ commit }, payload) => commit('setSelected', payload),

  setSelectedTab: ({ commit }, payload) => commit('setSelectedTab', payload),

  setSelectedStep: ({ commit }, payload) => commit('setSelectedStep', payload),

  setPages: ({ commit }, payload) => commit('setPages', payload),

  setActiveTab: ({ commit }, payload) => commit('setActiveTab', payload),

  setActiveStep: ({ commit }, payload) => commit('setActiveStep', payload),

  setCurrentMode: ({ commit }, payload) => commit('setCurrentMode', payload),

  setCurrentTemplate: ({ commit }, payload) => commit('setCurrentTemplate', payload),

  setSelectedPortal: ({ commit }, payload) => commit('setSelectedPortal', payload),

  setSelectedModule: ({ commit }, payload) => commit('setSelectedModule', payload),

  setSelectedEnvironment: ({ commit }, payload) => commit('setSelectedEnvironment', payload),

  setSelectedPage: ({ commit }, payload) => commit('setSelectedPage', payload),

  setSelectedItem: ({ commit }, payload) => commit('setSelectedItem', payload),

  setParents: ({ commit }, payload) => commit('setParents', payload),

  setAccordionType: ({ commit }, payload) => commit('setAccordionType', payload),

  setSelectedComponent: ({ commit }, payload) => commit('setSelectedComponent', payload),

  setSidebarTab: ({ commit }, payload) => commit('setSidebarTab', payload)
};
